import { ITextHTMLBlockJSON, ITextHTMLChildrenJSON } from 'types/domain/text';
import { Text } from 'slate';
import { useEffect, memo } from 'react';
import { isEmptyText } from 'utils/emptyText';

export default memo(function RenderText({
  htmlJson,
  className,
  onClick,
  onFocus,
  onBlur,
}: {
  htmlJson?: ITextHTMLBlockJSON[];
  className?: any;
  onClick?: (e) => void;
  onFocus?: (val) => void;
  onBlur?: (val) => void;
}) {
  if (!htmlJson || isEmptyText(htmlJson)) return null;

  const clickHandler = e => {
    if (onClick) onClick(e);
  };

  return (
    <div
      onFocus={e => (onFocus ? onFocus(e) : null)}
      onBlur={e => (onBlur ? onBlur(e) : null)}
      onClick={clickHandler}
      className={className}
    >
      {htmlJson.map && htmlJson.map((item, i) => <RenderElement key={i} element={item}></RenderElement>)}
    </div>
  );
});

function RenderElement({ element }) {
  const style = {
    textAlign: element.align,
    //backgroundColor: 'white',
    minHeight: `1em`,
  };

  switch (element.type) {
    case 'heading-one':
      return (
        <h1 style={style} className="howio-font-md">
          <ElementChildren node={element} />
        </h1>
      );
    case 'heading-two':
      return (
        <h2 style={style} className="howio-font-md">
          <ElementChildren node={element} />
        </h2>
      );
    case 'bulleted-list':
      return (
        <ul style={style} className="list-bullet">
          {element.children.map((child, i) => (
            <li key={i}>
              <ElementChildren node={child} />
            </li>
          ))}
        </ul>
      );
    case 'numbered-list':
      return (
        <ol style={style} className="list-numbered">
          {element.children.map((child, i) => (
            <li key={i}>
              <ElementChildren node={child} />
            </li>
          ))}
        </ol>
      );
    default:
      return (
        <p style={style}>
          <ElementChildren node={element} />
        </p>
      );
  }
}

function ElementChildren({ node }) {
  const hasText = node?.children?.some(child => child.text?.length > 0);

  return (
    <span className={hasText ? 'txt-node' : ''}>
      {node?.children?.map((item, i) => (
        <ElementChild key={i} node={item} />
      ))}
    </span>
  );
}

function ElementChild({ node }: { node: ITextHTMLChildrenJSON }) {
  if (node.type === 'link') {
    return (
      <a href={node.url} target="_blank" className="underline cursor-pointer" rel="noreferrer">
        <ElementChildren node={node} />
      </a>
    );
  }

  if (Text.isText(node)) {
    let string = node.text;
    let css = '';
    if (node.bold) {
      css += ' bold';
    }

    if (node.italic) {
      css += ' italic';
    }

    if (node.underline) {
      css += ' underline';
    }

    if (css === '') return <span>{string}</span>;

    if (string) return <span className={css}>{string}</span>;
  }
  return <span></span>;
}
